import { render, staticRenderFns } from "./DailyChallengeCard.vue?vue&type=template&id=26925e21&scoped=true&"
import script from "./DailyChallengeCard.vue?vue&type=script&lang=ts&"
export * from "./DailyChallengeCard.vue?vue&type=script&lang=ts&"
import style0 from "./DailyChallengeCard.vue?vue&type=style&index=0&id=26925e21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26925e21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('26925e21', component.options)
    } else {
      api.reload('26925e21', component.options)
    }
    module.hot.accept("./DailyChallengeCard.vue?vue&type=template&id=26925e21&scoped=true&", function () {
      api.rerender('26925e21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/dailyproblems/components/DailyChallengeCard.vue"
export default component.exports